import { forwardRef } from 'react'

import { TextContainer } from 'components/container'
import { Section, Title } from 'components/misc'
import { Details } from 'components/details'
import DetailsPoster from './assets/const.webp'


export const Independence = forwardRef<HTMLDivElement, {}>((_, ref) => (
  <Section ref={ref}>
    <TextContainer>
      <Title data-menu-title="суверенитет">Суверенитет Республики Саха </Title>

      <p>
        В годы перестройки Якутская АССР стала одной из первых республик, объявивших о своем суверенитете. Это произошло 27 сентября 1990 года, через месяц после знаменитого выступления президента РСФСР Бориса Ельцина, в котором он{' '}
        <a
          href="https://yeltsin.ru/news/boris-elcin-berite-stolko-suverineteta-skolko-smozhete-proglotit/"
          target="_blank"
          rel="noreferrer"
        >
          сказал
      </a>{' '}
        : "Берите столько суверенитета, сколько сможете проглотить". Но определенные уступки все же были сделаны для Москвы: созданные новые государственные структуры передали часть своих полномочий РСФСР и существовавшему тогда СССР при заключении федерального и союзного договоров.
      </p>

      <p>
        С развалом Советского Союза в 1991 году местные власти официально сменили название на Республика Саха (Якутия), учредили пост президента – на него избрали Михаила Николаева – и прописали широкие полномочия для республики. Через год была принята Конституция. С этого момента местные власти сами могли регулировать отношения как с Россией, так и с иностранными государствами. Некоторое время, чтобы попасть на определенные территории республики, жителям остальной части России требовалась "виза" или специальное приглашение.
      </p>
    </TextContainer>

    <Details posterImage={DetailsPoster}>
      <TextContainer>

        <p>
          В качестве государственных языков провозгласили саха и русский, к официальным языкам отнесли еще несколько языков других коренных народов, проживающих на территории республики. В 1999-м власти также{' '}
          <a
            href="https://nikolaevcentre.ru/archive/view/doc/177"
            target="_blank"
            rel="noreferrer"
          >

            сделали
          </a>{' '}
          английский рабочим языком, обязали всех чиновников выучить язык и ввести его обучение во всех учебных заведениях.
      </p>
        <p>
          Регион, который является мировым лидером по алмазодобыче, также получил право пользования всеми природными ресурсами. На практике это означало, что доход от добычи алмазов, нефти и газа направлялся в республиканский бюджет. Как позже писали российские СМИ, это стало основной причиной конфликта с федеральным центром.
      </p>
        <p>
          После избрания президентом Владимира Путина в 2000 году у республики постепенно начали отбирать имеющиеся свободы. Путин требовал пересмотреть разграничение полномочий между регионами в целом. Под давлением Москвы депутаты Республики Саха были вынуждены вносить правки в Конституцию из-за "несоответствия" федеральному законодательству. В 2009 году Конституционный суд России{' '}
          <a
            href="https://lenta.ru/news/2009/06/08/sovereign/"
            target="_blank"
            rel="noreferrer"
          >
            потребовал
        </a>{' '}
          от Республики Саха (а также от Татарстана, Башкортостана и Тывы) исключить положение о суверенитете, местным властям пришлось подчиниться.
      </p>
        <p>
          Все ключевые вопросы государственного управления отныне было необходимо согласовывать с Москвой, доход от добычи природных ископаемых практически полностью стал уходить в федеральный бюджет. В 2014 году упразднили пост президента, с этого времени эта должность называется глава республики.
      </p>
      </TextContainer>
    </Details>
  </Section>
))
